module.exports = require('./dist/react-luck-draw.cjs.js')
